import { supabaseClient } from "supabase/supabase";

export const deleteUser = async ({ uid }: { uid: string }) => {
  const query = supabaseClient.from("users").delete().eq("uid", uid);
  const { error } = await query;
  if (error) {
    throw error;
  }

  const { data: list } = await supabaseClient.storage.from("users").list(uid);

  if (list) {
    const filesToRemove = list.map((x) => `${uid}/${x.name}`);

    const { error: storageError } = await supabaseClient.storage
      .from("users")
      .remove(filesToRemove);
    if (storageError) {
      throw storageError;
    }
  }

  return null;
};
